import { appointmentConstants } from "../constants";
import { appointmentService } from "../../services";
import { history } from "../../helpers";
import Swal from "sweetalert2";
import { constants } from "../../Constants";

export const AppointmentActions = {
    AdminCreateAppointment,
};

function AdminCreateAppointment(current_time, slotTime, patientId, counsellor_id) {
    return (dispatch) => {
      dispatch(request());
      appointmentService
        .AdminCreateAppointment(current_time, slotTime, patientId, counsellor_id)
        .then((resp) => {
          if (resp.ok) {
            Swal.fire({
              title: constants.APPOINTMENT_CREATED_TXT,
              icon: constants.SUCCESS_TEXT,
              confirmButtonText: constants.OK_TXT,
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch(success());
            history.replace("/home");
          } else if (resp.ok === false) {
            resp.json().then((err) => {
              let possible_errors = ["error", "slot_id", "0"];
              if (err) {
                for (var key in err) {
                  if (possible_errors.includes(key)) {
                    Swal.fire({
                      title: constants.SAAYA_HEALTH_TXT,
                      text: err[key],
                      icon: constants.ERROR_TEXT,
                      confirmButtonText: constants.OK_TXT,
                      onOpen: function () {
                        Swal.getPopup()
                          .querySelector(".swal2-confirm")
                          .setAttribute("id", "btnSuccess");
                      },
                    });
                    dispatch(failure(err[key]));
                  }
                }
              } else {
                dispatch(
                  failure("appointment could not be created at this time.")
                );
              }
            });
          } else if (resp.status === 400) {
            Swal.close();
            Swal.fire({
              title: constants.SAAYA_HEALTH_TXT,
              text: constants.APPOINTMENT_CAN_NOT_CREATED_TXT,
              icon: constants.ERROR_TEXT,
              confirmButtonText: constants.OK_TXT,
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch({
              type: appointmentConstants.ADMIN_APPOINTMENTS_FAILURE,
              data: null,
            });
          } else {
            Swal.close();
            Swal.fire({
              title: constants.SAAYA_HEALTH_TXT,
              text: constants.APPOINTMENT_CAN_NOT_CREATED_TXT,
              icon: constants.ERROR_TEXT,
              confirmButtonText: constants.OK_TXT,
              onOpen: function () {
                Swal.getPopup()
                  .querySelector(".swal2-confirm")
                  .setAttribute("id", "btnSuccess");
              },
            });
            dispatch({
              type: appointmentConstants.ADMIN_APPOINTMENTS_FAILURE,
              data: null,
            });
          }
        })
        .catch((err) => {
          Swal.close();
          Swal.fire({
            title: constants.SAAYA_HEALTH_TXT,
              text: constants.APPOINTMENT_CAN_NOT_CREATED_TXT,
              icon: constants.ERROR_TEXT,
              confirmButtonText: constants.OK_TXT,
            onOpen: function () {
              Swal.getPopup()
                .querySelector(".swal2-confirm")
                .setAttribute("id", "btnSuccess");
            },
          });
          dispatch(failure(err));
        });
    };
    function request() {
        return { type: appointmentConstants.ADMIN_APPOINTMENTS_REQUEST };
      }
      function success() {
        return { type: appointmentConstants.ADMIN_APPOINTMENTS_SUCCESS };
      }
      function failure(error) {
        return {
          type: appointmentConstants.ADMIN_APPOINTMENTS_FAILURE,
          error,
        };
      }
}




// WEBPACK FOOTER //
// ./src/store/actions/appointment.actions.js